import { SearchByCnpjService } from 'data/services';
import { SearchByCnpjServiceInterface } from 'domain/services';
import { makeGetSearchCnpj } from 'main/factories/usecases/search-by-cnpj/remote-get-search-by-cnpj';

export const makeSearchBycNPJService = (): SearchByCnpjServiceInterface => {
  return new SearchByCnpjService({
    searchByCnpj: makeGetSearchCnpj(),
  });
};
